module.exports = __webpack_public_path__ + "assets/img/pizza_2.2094a8f3.png";